import {
  Button,
  CardContent,
  Grid,
  Divider,
  TextField,
  Typography,
  Table,
  Select,
  MenuItem,
  Paper,
  Autocomplete,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import CustomLabel from "../../../CustomLable";

import { Language } from "react-transliterate";
import Languages from "../../../utils/Languages";
import api from "../../../utils/Url";
import { getId, getISTDate } from "../../../utils/Constant";

const CreatePurchaseOrder = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const initialRows: any = {
    id: -1,
    purchaseid: -1,
    user_Id: 0,
    itemNameId: '',
    unit: "",
    qty: '',
    rate: '',
    amount: '',
    tax1: "",
    taxId1: "",
    taxId2: "",
    tax2: "P",
    discount: 0,
    discountAmount: '',
    netAmount: '',
    documentNo: "",
    documentDate: new Date().toISOString(),
    invoiceNo: "",
    supplier: "",
    orderNo: "",
    mrnNo: "",
    mrnDate: "",
    taxId3: "",
    tax3: "",
  };
  const { defaultValuestime } = getISTDate();
  const [lang, setLang] = useState<Language>("en");
  const [toaster, setToaster] = useState(false);
  const [items, setItems] = useState<any>([{ ...initialRows }]);
  const [taxOption, setTaxOption] = useState([
    { value: "-1", label: t("text.SelectTax") },
  ]);
  const [unitOptions, setUnitOptions] = useState([
    { value: "-1", label: t("text.SelectUnitId") },
  ]);
  const [contentOptions, setContentOptions] = useState([
    { value: "-1", label: t("text.SelectContentId") },
  ]);

  const [Option, setOption] = useState([
    { value: "-1", label: t("text.SelectSupplierName") },
  ]);


  const [Option1, setOption1] = useState([
    { value: "-1", label: t("text.SelectIndent") },
  ]);

  const UserId = getId();

  const back = useNavigate();

  useEffect(() => {
    GetDigitalContentData();
    getTaxData();
    GetUnitData();
    getSupliar();
    getDocNo();
    getIndent();
  }, []);

  const getDocNo = async () => {
    const res = await api.post(`PurchaseInvoice/GetMaxDocumentNo`);
    formik.setFieldValue("document_No", res?.data?.data[0]?.document_No);
  };

  const getSupliar = async () => {
    const collectData = {
      venderId: -1
    };
    const response = await api.post(`VendorMaster/Ge3tVendorMaster`, collectData);
    const data = response.data.data;
    const arr = data.map((vendor: any) => ({
      label: vendor.name,
      value: vendor.venderId,
      // details: vendor
    }));
    setOption(arr);
  };


  const getIndent = async () => {

    const collectData = {
      "qcId": -1,
      "qcNo": "",
      "mrnId": -1,
      "storeid":-1,
      "vendorId": -1,
      "fromDate": null,
      "toDate": null,
      "show": true,
      "exportOption": ".pdf",
      "type": 0
  };

    const response = await api.post(`Qc/GetQc`,collectData);
    const data = response.data.data;




    const arr = data

      .map((indent: any) => ({
        label: `${indent?.qcNo} - ${indent?.vendor}`,
        value: indent?.qcId,
        vendorId: indent?.vendorId,
        vendor: indent?.vendor,
      }));
    setOption1(arr);
  };
  const getTaxData = async () => {
    const res = await api.post(`/TaxMaster/GetTaxMaster`, { taxId: -1 });
    const arr =
      res?.data?.data?.map((item: any) => ({
        label: item.taxName,
        value: item.taxId,
      })) || [];

    setTaxOption(arr);
  };
  const GetUnitData = async () => {
    const collectData = {
      unitId: -1,
    };
    const response = await api.post(`UnitMaster/GetUnitMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["unitName"],
        value: data[index]["unitId"],
      });
    }
    setUnitOptions(arr);
  };

  const GetDigitalContentData = async () => {
    const collectData = {
      itemMasterId: -1,
    };
    const response = await api.post(`ItemMaster/GetItemMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["itemName"],
        value: data[index]["itemMasterId"],
        taxId: data[index]["taxId"]
      });
    }
    // for (let index = 0; index < data.length; index++) {
    //   arr.push({
    //     label: data[index]["title"],
    //     value: data[index]["id"],
    //     rate: data[index]["exRate"],
    //     unitId: data[index]["unitId"],
    //     unitname: data[index]["unitname"],
    //     taxId: data[index]["taxId"],
    //     taxName: data[index]["taxName"],
    //   });
    // }
    setContentOptions(arr);
  };

  const validateItem = (item: any) => {
    // console.log("🚀 ~ validateItem ~ item:", item);
    return (
      item.itemNameId &&
      item.unit &&
      item.qty &&
      item.rate &&
      item.amount &&
      item.tax1 &&
      item.taxId1
    );
  };

  const handleItemChange = (index: number, field: string, value: any) => {
    const updatedItems = [...items];
    let item = { ...updatedItems[index] };

    if (field === 'itemNameId') {
      const itemNameDetails = value;
      if (itemNameDetails) {
        item = {
          ...item,
          itemNameId: itemNameDetails.value || "",
          
          taxId1: String(itemNameDetails.taxName) || "",

        };
      }
    } else if (field === 'qty' || field === 'rate') {
      item[field] = value === "" ? 0 : parseFloat(value);
      item.amount = calculateAmount(item.qty, item.rate);
      item.taxId2 = String(calculateTax(item.amount, Number(item.taxId1)));
    } else if (field === 'tax1') {
      const selectedTax = taxOption.find((tax: any) => tax.value === value?.value);
      if (selectedTax) {
        item.tax1 = String(selectedTax.value);

        item.taxId2 = String(calculateTax(item.amount, Number(selectedTax.label)));
        item.taxId1 = String(selectedTax.label);
      }
    } else if (field === 'tax2') {
      item.tax2 = value || '';
    } else if (field === 'unit') {
      item[field] = value;
    } else if (field === 'discount') {
      item.discount = value === '' ? 0 : parseFloat(value);
      const discountAmount = calculateDiscount(item.amount, item.discount, item.tax2);
      item.discountAmount = discountAmount;
      item.netAmount = calculateNetAmount(item.amount, Number(item.taxId2), discountAmount);
    }

    // Recalculate dependent fields
    if (field !== 'discount' && field !== 'tax2') {
      const discountAmount = calculateDiscount(item.amount, item.discount, item.tax2);
      item.discountAmount = discountAmount;
      item.netAmount = calculateNetAmount(item.amount, Number(item.taxId2), discountAmount);
    }

    updatedItems[index] = item;
    setItems(updatedItems);

    // if (validateItem(item) && index === updatedItems.length - 1) {
    //   handleAddItem(updatedItems);
    // }


    //console.log("🚀 ~ Updated items:", updatedItems);
  };

  const calculateAmount = (qty: number, rate: number) => qty * rate;

  const calculateTax = (amount: number, taxRate: number) => {
    const tax = (amount * taxRate) / 100;
    return tax.toFixed(2);
  };

  const calculateDiscount = (amount: number, discount: number, type: string) => {
    if (type === 'P') { // Percentage-based discount
      return (amount * discount) / 100;
    } else if (type === 'F') { // Fixed discount
      return discount;
    }
    return 0;
  };

  const calculateNetAmount = (
    amount: number,
    tax: number,
    discount: number
  ) => {
    console.log("amount tax discount", amount, tax, discount);
    const netAmount = Number(amount) + Number(tax) - Number(discount);
    console.log("netAmount", netAmount);
    return netAmount.toFixed(2);
  };


  const handleRemoveItem = (index: number) => {
    if (items.length === 1) {
      setItems([{ ...initialRows }]);
    } else {
      const newData = items.filter((_: any, i: any) => i !== index);
      setItems(newData);
    }
    // updateTotalAmounts(tableData);
  };

  const handleAddItem = (items: any) => {
    setItems([
      ...items,
      {
        id: -1,
        purchaseid: -1,
        user_Id: 0,
        itemNameId: "",
        unit: "",
        qty: '',
        rate: '',
        amount: '',
        tax1: "",
        taxId1: "",
        tax2: "P",
        discount: 0,
        discountAmount: '',
        netAmount: '',
        documentNo: formik.values.document_No,
        documentDate: formik.values.doc_Date,
        invoiceNo: formik.values.p_InvoiceNo,
        supplier: formik.values.supplierName,
        orderNo: formik.values.orderNo,
        mrnNo: "",
        mrnDate: defaultValuestime,
        taxId3: "",
        tax3: "",
      },
    ]);
  };

  const totalAmount = items.reduce(
    (acc: any, item: any) => acc + Number(item.netAmount),
    0
  );

  const formik: any = useFormik({
    initialValues: {
      purchaseid: -1,
      document_No: "",
      p_InvoiceNo: "",
      doc_Date: new Date().toISOString().slice(0, 10),
      p_InvoiceDate: new Date().toISOString().slice(0, 10),
      supplierName: "",
      supplierId: 0,
      orderNo: "",
      tax: "",
      freight: 0,
      amount: 0,
      acc_code: "",
      others: "",
      remark: "",
      instId: 0,
      sessionId: 0,
      "createdBy":UserId,
      "updatedBy":UserId,
      "createdOn":new Date().toISOString(),
      "updatedOn":new Date().toISOString(),
      purchaseinv: [],
    },
    validationSchema: Yup.object().shape({
      // document_No: Yup.string().required(t("Document No. required")),
      orderNo: Yup.string().required(t("Order No. required")),
      doc_Date: Yup.date().required(t("Order Date required")),
      p_InvoiceDate: Yup.date().required(t("Invoice Date required")),
      supplierName: Yup.string().required("Supplier Name required"),
    }),
    onSubmit: async (values) => {
      console.log("Form Submitted with values:", values);
      console.log("Formik Errors:", formik.errors);
      values.amount = totalAmount

      const validItems = items.filter((item: any) => validateItem(item));

      if (validItems.length === 0) {
        alert("Please fill  data in tabel");
        return;
      }
      //console.log("🚀 ~ onSubmit: ~ validateItem(item):", validateItem(item))

      // Check if there are valid items
      // if (validItems.length === 0) {
      //     console.log("🚀 ~ onSubmit: ~ validItems:", validItems)
      //     alert("Please fill in at least one valid item.");
      //     return;
      // }

      // Map the valid items, setting values at the first index
      const updatedItems = validItems.map((item: any, index: any) => {
        const baseItem = {
          ...item,

          documentNo: values.document_No,

          documentDate: values.doc_Date,

          invoiceNo: values.p_InvoiceNo,
          supplier: values.supplierName,
          orderNo: values.orderNo,
          mrnNo: "",
          mrnDate: defaultValuestime,
          user_Id: 1,

          tax3: "",
        };


        if (index === 0) {
          return baseItem;
        }
        return item;
      });
      values.purchaseinv = updatedItems;

      console.log("Form Submitted with values:", values);
      console.log("Updated Items:", updatedItems);

      try {
        // console.log("hi");
        const response = await api.post(
          `PurchaseInvoice/AddUpdatePurchaseInvoice`,
          values
        );
        if (response.data.isSuccess) {
          setToaster(false);
          toast.success(response.data.mesg);
          setTimeout(() => {
            navigate("/Inventory/PurchaseInvoice");
          }, 700);

        } else {
          setToaster(true);
          toast.error(response.data.mesg);
        }
      } catch (error) {
        setToaster(true);
        toast.error(t("error.network"));
      }
    },
  });

  console.log("items", items);


  const getPurchaseOrderByIndent = async (id: any) => {

    const collectData = {
      "qcId": id,
      "qcNo": "",
      "mrnId": -1,
      "storeid":-1,
      "vendorId": -1,
      "fromDate": null,
      "toDate": null,
      "show": true,
      "exportOption": ".pdf",
      "type": 0
  };

   
    const response = await api.post(`Qc/GetQc`,collectData);
    //const data = response.data.data;
    const transData = response?.data?.data[0]["qcDetail"];

    let arr: any = [];
    for (let i = 0; i < transData.length; i++) {
      arr.push({
        id: -1,
        purchaseid: -1,
        user_Id: transData[i]["user_id"] || 1,
        itemNameId: transData[i]["itemId"],
        unit: String(transData[i]["unitId"]) || 0,
        qty: transData[i]["acceptQty"],
        rate: transData[i]["rate"],
        amount: transData[i]["amount"],
        tax1: String(transData[i]["gstId"]),
        taxId1: transData[i]["gstRate"],
        taxId2: transData[i]["totalGst"],
        tax2: transData[i]["tax2"] || "",
        discount: transData[i]["discount"] || 0,
        discountAmount: transData[i]["discountAmount"] || 0,
        netAmount: transData[i]["netAmount"],
        documentNo: transData[i]["documentNo"] || formik.values.document_No,
        documentDate: transData[i]["documentDate"] || formik.values.doc_Date,
        invoiceNo: transData[i]["invoiceNo"] || formik.values.p_InvoiceNo,
        supplier: transData[i]["supplierId"] || formik.values.supplierName,
        orderNo: transData[i]["orderNo"] || formik.values.orderNo,
        mrnNo: transData[i]["mrnNo"] || "",
        mrnDate: transData[i]["mrnDate"] || defaultValuestime,
        taxId3: transData[i]["taxId3"],
        tax3: transData[i]["tax3"] || "",

      });
    }
    // arr.push({ ...initialRows });
    setItems(arr);
  };



  return (
    <div>
      <div
        style={{
          padding: "5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #FF7722",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Grid item xs={12} container spacing={2}>
            <Grid item lg={2} md={2} xs={2} marginTop={2}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  backgroundColor: "blue",
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Grid>
            <Grid
              item
              lg={7}
              md={7}
              xs={7}
              alignItems="center"
              justifyContent="center"
            >
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ padding: "20px" }}
                align="center"
              >
                {t("text.Purchaseorder")}
              </Typography>
            </Grid>

            <Grid item lg={3} md={3} xs={3} marginTop={3}>
              <select
                className="language-dropdown"
                value={lang}
                onChange={(e) => setLang(e.target.value as Language)}
              >
                {Languages.map((l: any) => (
                  <option key={l.value} value={l.value}>
                    {l.label}
                  </option>
                ))}
              </select>
            </Grid>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster && <ToastApp />}
            <Grid item xs={12} container spacing={2}>
              <Grid item lg={4} xs={12}>
                <TextField
                  id="document_No"
                  name="document_No"
                  label={
                    <CustomLabel text={t("text.document_No")} required={false} />
                  }
                  value={formik.values.document_No}
                  placeholder={t("text.document_No")}
                  size="small"
                  fullWidth
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>


              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={Option1}
                  //   value={
                  //     Option.find(
                  //       (option: any) => option.value === formik.values.stateId
                  //     ) || null
                  //   }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("supplierId", newValue?.vendorId);
                    formik.setFieldValue("supplierName", newValue?.vendor);
                    

                    getPurchaseOrderByIndent(newValue?.value)


                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}

                      label={
                        <CustomLabel
                          text={t("text.SelectQC")}
                          required={false}

                        />
                      }
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.p_InvoiceNo")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="p_InvoiceNo"
                  id="p_InvoiceNo"
                  // type="date"
                  value={formik.values.p_InvoiceNo}
                  placeholder={t("text.p_InvoiceNo")}
                  onChange={formik.handleChange}
                />
              </Grid>

              {/* <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel text={t("text.doc_Date")} required={false} />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="doc_Date"
                  id="doc_Date"
                  type="date"
                  value={formik.values.doc_Date}
                  placeholder={t("text.doc_Date")}
                  onChange={formik.handleChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid> */}

              <Grid item lg={4} xs={12}>
                <TextField
                  id="p_InvoiceDate"
                  name="p_InvoiceDate"
                  label={
                    <CustomLabel
                      text={t("text.p_InvoiceDate")}
                      required={true}
                      value={formik.values.p_InvoiceDate}
                    />
                  }
                  value={formik.values.p_InvoiceDate}
                  placeholder={t("text.p_InvoiceDate")}
                  size="small"
                  type="date"
                  fullWidth
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputLabelProps={{ shrink: true }}
                  error={
                    formik.touched.p_InvoiceDate &&
                    Boolean(formik.errors.p_InvoiceDate)
                  }
                  helperText={
                    formik.touched.p_InvoiceDate && formik.errors.p_InvoiceDate
                  }
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={Option}
                  value={
                      Option.find(
                        (option: any) => option.value === formik.values.supplierId
                      ) || null
                    }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);

                    formik.setFieldValue("supplierId", newValue?.value);
                    formik.setFieldValue("supplierName", newValue?.label);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={
                        formik.touched.supplierName &&
                        Boolean(formik.errors.supplierName)
                      }
                      helperText={
                        formik.touched.supplierName && formik.errors.supplierName
                      }
                      label={
                        <CustomLabel
                          text={t("text.SelectSupplierName")}
                          required={true}
                          value={formik.values.supplierName}
                        />
                      }
                    />
                  )}
                />
              </Grid>




              <Grid item lg={4} xs={12}>
                <TextField
                  id="orderNo"
                  name="orderNo"
                  label={
                    <CustomLabel text={t("text.orderNo")} required={true} value={formik.values.orderNo} />
                  }
                  value={formik.values.orderNo}
                  placeholder={t("text.orderNo")}
                  size="small"
                  fullWidth
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.orderNo && Boolean(formik.errors.orderNo)
                  }
                  helperText={formik.touched.orderNo && formik.errors.orderNo}
                />
              </Grid>



              <Grid item lg={4} xs={12}>
                <TextField
                  id="remark"
                  name="remark"
                  label={
                    <CustomLabel text={t("text.remark")} required={false} />
                  }
                  value={formik.values.remark}
                  placeholder={t("text.remark")}
                  size="small"
                  fullWidth
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                //error={formik.touched.remark && Boolean(formik.errors.remark)}
                //helperText={formik.touched.remark && formik.errors.remark}
                />
              </Grid>

              <Grid item lg={12} md={12} xs={12} textAlign={"center"}>
                {/* <Typography variant="h6" textAlign="center">
                  {t("text.Purchaseorder")}
                </Typography> */}
              </Grid>

              <Grid item lg={12} md={12} xs={12}>
                {/* <TableContainer> */}
                <Table
                  style={{
                    borderCollapse: "collapse",
                    width: "100%",
                    border: "1px solid black",
                  }}
                >
                  <thead
                    style={{ backgroundColor: "#2B4593", color: "#f5f5f5" }}
                  >
                    <tr>
                      {/* <TableCell style={{ color: '#fff' }}>Sr. No.</TableCell> */}
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}
                      >
                        {t("text.ItemName")}
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}
                      >
                        {t("text.unit")}
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}
                      >
                        {t("text.Quantity")}
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}
                      >
                        {t("text.Rate")}
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}
                      >
                        {t("text.Amount")}
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}
                      >
                        {t("text.Tax")}
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}

                        title="Tax Ammout"
                      >
                        {t("text.TaxAmount")}
                      </th>
                      {/* <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}
                        title="Discount Type"
                      >
                        {t("text.DiscountType")}
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}
                        title="Discount"
                      >
                        {t("text.Discount")}
                      </th> */}
                      {/* <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}

                        title="Discount Ammount"
                      >
                        {t("text.DiscountAmount")}
                      </th> */}
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}
                      >
                        {t("text.NetAmount")}
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}
                      >
                        {t("text.Action")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item: any, index: any) => (
                      <tr key={item.id} style={{ border: "1px solid black" }}>
                        {/* <TableCell>{index + 1}</TableCell> */}
                        <td style={{ width: "220px", padding: "5px" }}>
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={contentOptions}

                            value={
                              contentOptions.find(
                                (opt: any) => opt.value == item.itemNameId
                              ) || null
                            }
                            size="small"
                            onChange={(event, newValue: any) => {
                              handleItemChange(index, "itemNameId", newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={t("text.enteritem")}
                              />
                            )}
                          />
                        </td>
                        <td style={{ width: "180px", padding: "5px" }}>
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={unitOptions}
                            size="small"
                            value={
                              unitOptions.find(
                                (opt: any) => opt.value == item.unit
                              ) || null
                            }
                            onChange={(event, newValue) =>
                              handleItemChange(
                                index,
                                "unit",
                                newValue?.value?.toString()
                              )
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={t("text.unit")}
                              />
                            )}
                          />
                        </td>
                        <td>
                          <TextField
                            type="text"
                            value={item.qty}
                            onChange={(e) =>
                              handleItemChange(
                                index,
                                "qty",
                                (e.target.value)
                              )
                            }
                            size="small"
                            InputProps={{ readOnly: true, }}
                          />
                        </td>
                        <td>
                          <TextField
                            type="text"
                            value={item.rate}
                            onChange={(e) =>
                              handleItemChange(
                                index,
                                "rate",
                                (e.target.value)
                              )
                            }

                            InputProps={{ readOnly: true, }}
                            size="small"
                          />
                        </td>
                        <td>{item.amount}</td>
                        <td>
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={taxOption}
                            size="small"
                            value={
                              taxOption.find(
                                (opt: any) => opt.value == item.tax1
                              ) || null
                            }
                            onChange={(event, newValue: any) => {
                              handleItemChange(
                                index,
                                "tax1",
                                newValue
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={t("text.SelectTax")}
                              />
                            )}
                          />
                        </td>
                        <td>{item.taxId2}</td>
                        {/* <td>
                          <Select
                            value={item.tax2}
                            onChange={(e: any) =>
                              handleItemChange(index, "tax2", e.target.value)
                            }
                            size="small"
                          >
                            <MenuItem value="P">Pct(%)</MenuItem>
                            <MenuItem value="F">Fix</MenuItem>
                          </Select>
                        </td>
                        <td>
                          <TextField
                            type="text"
                            value={item.discount}
                            onChange={(e) =>
                              handleItemChange(
                                index,
                                "discount",
                                (e.target.value)
                              )
                            }
                            onFocus={(e) => e.target.select()}
                            size="small"
                          />
                        </td>
                        <td>{item.discountAmount}</td> */}
                        <td>{item.netAmount}</td>
                        <td>
                          <Button
                            onClick={() => handleRemoveItem(index)}
                            variant="text"
                            color="secondary"
                          >
                            <DeleteIcon />
                          </Button>
                        </td>
                      </tr>
                    ))}
                    <tr style={{ backgroundColor: "#2B4593" }}>
                      <td colSpan={8} style={{ textAlign: "right" }}>
                        <strong style={{ color: "#fff" }}>
                          {t("text.totalAmount")}:
                        </strong>
                      </td>
                      <td colSpan={3}>
                        <strong style={{ color: "#fff" }}>
                          {totalAmount}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </Table>
                {/* </TableContainer> */}
              </Grid>

              <Grid item xs={12}>
                <div style={{ justifyContent: "space-between", flex: 2 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    style={{
                      width: "48%",
                      backgroundColor: `var(--header-background)`,
                      margin: "1%",
                    }}
                  >
                    {t("text.save")}
                  </Button>

                  <Button
                    type="reset"
                    variant="contained"
                    style={{
                      width: "48%",
                      backgroundColor: "#F43F5E",
                      margin: "1%",
                    }}
                    onClick={() => formik.resetForm()}
                  >
                    {t("text.reset")}
                  </Button>
                </div>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default CreatePurchaseOrder;
